import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './styles/styles.css';

/** Last-resort error boundary: an unexpected render error used to unmount the
 *  whole tree to a silent blank page. Show what happened + a reload button
 *  instead (state lives on the server, so a reload is always safe). */
class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  override componentDidCatch(error: Error, info: React.ErrorInfo) { console.error('HEROs crashed:', error, info.componentStack); }
  override render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui, sans-serif', background: '#f6f5f2', color: '#28323c', padding: 24 }}>
          <div style={{ maxWidth: 520, textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
            <h2 style={{ margin: '0 0 8px' }}>Something went wrong on this screen</h2>
            <p style={{ fontSize: 14, color: '#5a6672', margin: '0 0 6px' }}>
              Your data is safe on the server — nothing was lost. Reload to continue.
            </p>
            <p style={{ fontSize: 11, color: '#8a949e', margin: '0 0 16px', fontFamily: 'monospace' }}>
              {String(this.state.error?.message || this.state.error)}
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '10px 22px', fontSize: 14, fontWeight: 600, color: '#fff', background: '#1f3a5f', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
              ↻ Reload HEROs
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
